<template>
  <Layout :show-links="false">
    <Jumbotron :authorizationLink="{}" errorPage :title="$t('generating')" />
    <Cards />
    <JumbotronSmall :authorizationLink="{}" errorPage />
  </Layout>
</template>

<script>
import Jumbotron from "@/components/homepage/Jumbotron";
import JumbotronSmall from "@/components/homepage/JumbotronSmall";
import Cards from "@/components/homepage/Cards";

export default {
  components: {
    Jumbotron,
    JumbotronSmall,
    Cards
  },
  metaInfo() {
    return {
      title: this.$t("portal"),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$t("description")
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: this.$t("description")
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: "summary_large_image"
        }
      ]
    };
  }
};
</script>
